import React, { useEffect, useRef } from "react";

import { observer } from "mobx-react-lite";
import { TCText } from "../../../components/TCText/TCText";
import { Colors } from "../../../utils/colors";
import {
  useMatchDetailsStore,
  useMatchStatsStore,
} from "../../../stores/StoreContext";
import { ClutterGraphTopSection } from "./ClutterGraphTopSection";
import { ClutterGraphBoundaryDistribution } from "./ClutterGraphBoundaryDistribution";
import { DownloadUltraAppOverlay } from "../../ultraPromo/components/DownloadUltraAppOverlay";

type props = {};

export const MatchShotPatternsGraph: React.FC<props> = observer(() => {
  const matchDetailsStore = useMatchDetailsStore();
  return (
    <div style={styles.container}>
      <TCText
        value={`${matchDetailsStore.clutchMatchCurrentPlayer.name}'s shots`}
        style={styles.text}
      />
      <div style={{ position: "relative" }}>
        <ClutterPointPlotGraph />
        {matchDetailsStore.isPromoMode ? (
          <DownloadUltraAppOverlay
            style={{ top: 0 }}
            textStyle={{ color: Colors.black }}
          />
        ) : null}
      </div>
    </div>
  );
});

export const ClutterPointPlotGraph: React.FC<props> = () => {
  const matchStatsStore = useMatchStatsStore();
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef.current) {
      const { offsetWidth, offsetHeight } = containerRef.current;
      matchStatsStore.setWidth(offsetWidth);
      matchStatsStore.setHeight(offsetHeight);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={styles.clutterContainer}>
      <ClutterGraphTopSection />
      <div style={styles.thinBar} />
      <div ref={containerRef} style={styles.graphBoundary}>
        <ClutterGraphBoundaryDistribution isShowClutterGraph />
      </div>
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  container: { marginTop: 30 },
  text: {
    fontWeight: "600",
    fontSize: 16,
    color: Colors.black,
    marginLeft: 5,
  },
  clutterContainer: {
    alignItems: "center",
    marginTop: 10,
    display: "flex",
    flexDirection: "column",
  },
  thinBar: {
    height: 5,
    width: "100%",
    backgroundColor: Colors.darkBrown,
    borderRadius: 3,
  },
  gridContainer: {
    height: "100%",
    width: "100%",
  },
  boundaryContainerStyle: {
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
  },
  graphBoundary: {
    height: 272,
    width: "97%",
    borderColor: Colors.darkBrown,
    borderWidth: 1,
    borderBottomRightRadius: 10,
    borderBottomLeftRadius: 10,
    borderStyle: "solid",
  },
};
